<rt-box class="skeleton-summary" layout-vertical>
  <rt-placeloader variant="item" class="skeleton-heading" />

  <div layout-horizontal layout-align-items-center margin-top>
    <div layout-horizontal layout-align-items-center class="skeleton-avatars">
      <rt-placeloader variant="item" class="skeleton-avatar" />
      <rt-placeloader variant="item" class="skeleton-avatar" />
      <rt-placeloader variant="item" class="skeleton-avatar" />
      <rt-placeloader variant="item" class="skeleton-avatar" />
    </div>

    <div layout-vertical layout-flex-1 class="skeleton-lines" margin-left>
      <rt-placeloader variant="item" class="skeleton-line" style="width: 25%" />
      <rt-placeloader variant="item" class="skeleton-line" style="width: 40%" />
      <rt-placeloader variant="item" class="skeleton-line" style="width: 30%" />
    </div>
  </div>
</rt-box>

<rt-box class="skeleton-results" layout-vertical margin-top>
  <rt-placeloader variant="item" class="skeleton-heading" />

  <div layout-vertical class="skeleton-question" margin-top>
    <rt-placeloader variant="item" class="skeleton-line" style="width: 45%" />
    <div layout-vertical class="skeleton-bars" margin-top>
      <rt-placeloader variant="item" class="skeleton-bar" style="width: 70%" />
      <rt-placeloader variant="item" class="skeleton-bar" style="width: 85%" />
      <rt-placeloader variant="item" class="skeleton-bar" style="width: 30%" />
      <rt-placeloader variant="item" class="skeleton-bar" style="width: 55%" />
    </div>
  </div>

  <div layout-vertical class="skeleton-question" margin-top>
    <rt-placeloader variant="item" class="skeleton-line" style="width: 35%" />
    <div layout-vertical class="skeleton-bars" margin-top>
      <rt-placeloader variant="item" class="skeleton-bar" style="width: 80%" />
      <rt-placeloader variant="item" class="skeleton-bar" style="width: 45%" />
      <rt-placeloader variant="item" class="skeleton-bar" style="width: 60%" />
    </div>
  </div>
</rt-box>

<rt-box class="skeleton-results" layout-vertical margin-top>
  <rt-placeloader variant="item" class="skeleton-heading" />

  <div layout-vertical class="skeleton-question" margin-top>
    <rt-placeloader variant="item" class="skeleton-line" style="width: 45%" />
    <div layout-vertical class="skeleton-bars" margin-top>
      <rt-placeloader variant="item" class="skeleton-bar" style="width: 70%" />
      <rt-placeloader variant="item" class="skeleton-bar" style="width: 85%" />
      <rt-placeloader variant="item" class="skeleton-bar" style="width: 30%" />
      <rt-placeloader variant="item" class="skeleton-bar" style="width: 55%" />
    </div>
  </div>

  <div layout-vertical class="skeleton-question" margin-top>
    <rt-placeloader variant="item" class="skeleton-line" style="width: 35%" />
    <div layout-vertical class="skeleton-bars" margin-top>
      <rt-placeloader variant="item" class="skeleton-bar" style="width: 80%" />
      <rt-placeloader variant="item" class="skeleton-bar" style="width: 45%" />
      <rt-placeloader variant="item" class="skeleton-bar" style="width: 60%" />
    </div>
  </div>
</rt-box>
